<p>mobile-clipart works!</p>
